module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-02-0d68cc2acb4c607f2ecfc13ea375c7b3.jpg";